import styled from 'styled-components';
import { fontSettings } from '../../../styles';

export const FormGroupTitleStyled = styled.div`
  margin: 0 0 24px 0;
  font-weight: 500;
  ${({ theme }): string => fontSettings(theme.FONT.SIZE_20, theme.FONT)}
`;
